module.exports = __webpack_public_path__ + "img/step6.8b6c96ed.png";